module.exports = __webpack_public_path__ + "img/knight4cf_banner.77f314bb.jpg";